<template>
    <div>
      <component-header
        title="Create Kyc"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="true"
        @back-press="$router.push('/tenant')"
      />
      <b-card>
        <s-kyc
          class="mt-2"
          ref="kycForm"
          @readKYC="KYCUpdate($event)"
          :documentList="documentList"
          :userID="(currentUser && currentUser._id) || ''"
        >
          <template v-slot:footer-button="data">
            <b-row class="mt-3 justify-content-center">
              <b-col md="2">
                <b-button
                  class="btn btn-block"
                  btn-color="primary"
                  :disabled="
                    !kycChangeObj.addressProofBack ||
                    !kycChangeObj.addressProofFront ||
                    !kycChangeObj.photoIdFront ||
                    !kycChangeObj.photoIdBack ||
                    !kycChangeObj.idproofNo ||
                    !kycChangeObj.addressproofNo
                  "
                  @click="AgreeToNext(data.data)"
                  >Update</b-button
                >
              </b-col>
            </b-row>
          </template>
        </s-kyc>
      </b-card>
    </div>
  </template>
  
  <script>
  import sKYC from "@/components/Tenant/KYC.vue";
  import ComponentHeader from "@/components/componentNewHeader";
  
  export default {
    name: "CreateUser",
    components: {
      "s-kyc": sKYC,
      ComponentHeader,
    },
    data() {
      return {
        currentUser: null,
        kycChangeObj: {},
        documentList: null,
      };
    },
    methods: {
      AgreeToNext(item) {
        const userId = this.currentUser && this.currentUser._id || "";
        this.$refs.kycForm
          .submitKyc(userId, "APPROVED")
          .then((result) => {
            this.$router.push({ path: "/tenant" });
          })
          .catch((error) => {});
      },
      KYCUpdate(event) {
        this.kycChangeObj = event;
      },
    },
    mounted() {
      this.currentUser = this.$route.params.userData;
    },
  };
  </script>
  